import React, { useContext, useEffect, useState } from 'react';
import { PageContext } from './../../context/PageContext';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
    dataLayer: {
        userId: '008',
        userProject: 'Union-Group',
        page: 'Contact'
    },
    dataLayerName: 'PageDataLayer'
}

const Contact = () => {
    TagManager.dataLayer(tagManagerArgs)
    const { brand, common, sample, handleNavLoad } = useContext(PageContext);
    const images = { brand, common, sample };
    let [location, setLocation] = useState({
        lat:  -6.227353,
        lng: 106.827294
    });
    const [cond, setCond] = useState({
        lat: 51.505,
        lng: -0.09,
        zoom: 13
    })
    useEffect(()=>{
        handleNavLoad(true);
    },[])
    const myIcon = L.icon({
        iconUrl: require("./../../assets/img/common/ic_location_pin.png"),
        //iconUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII=")marker-icon.png',
        iconSize: [20, 32],
        iconAnchor: [12.5, 41],
        popupAnchor: [0, -41],
        shadowUrl: null,
        shadowSize: null,
        shadowAnchor: null
      });
    return (
        <>
            {/* <div className="cover animated fadeIn delayp1" style={{  
                backgroundImage: `url(${images.common["bg_whats-on.jpg"]})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                height: "300px"
            }}>
            </div> */}
            <section className="section-contact py-main">
                <Container className="container-md">
                    <Row>
                        <div className="col-md-6 col-12 order-md-last px-0">
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3452.8439125446507!2d106.82552507616035!3d-6.22728376755381!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3e52243edf3%3A0xcd8589bb7e5f73b!2sThe%20Ritz%20-%20Carlton%2C%20Lingkar%20Mega%20Kuningan%2C%20RT.5%2FRW.2%2C%20Kuningan%2C%20Kuningan%20Tim.%2C%20Kecamatan%20Setiabudi%2C%20Kota%20Jakarta%20Selatan%2C%20Daerah%20Khusus%20Ibukota%20Jakarta%2012950!5e0!3m2!1sen!2sid!4v1577155428716!5m2!1sen!2sid" className="location-contact" frameborder="0" style={{border: "0"}} allowfullscreen=""></iframe> */}
                            <Map
                                center={location}
                                zoom={16}
                                scrollWheelZoom={false}
                                className="restaurant-map"
                            >
                                <div className="bg-map-gray">
                                </div>
                                    <TileLayer
                                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
                                    id="mapbox.streets"
                                    accessToken="pk.eyJ1Ijoic25kYW50aWtvZGUiLCJhIjoiY2p6cnZ0NTcxMWM1YzNtbnBlZmJ2NzlkcyJ9.dZd20RU0nnsrWS7yprgGyw"
                                    />
                                    <Marker draggable position={location} icon={myIcon}>
                                        <Popup>Marker</Popup>
                                    </Marker>
                            </Map>
                        </div>
                        <div className="col-md-6 col-12 col-md-first bg-white">
                            <div className="general-box">
                                <div className="heading">
                                    <h1 className="text-uppercase mb-3">Get In Touch</h1>
                                    <p className="title sm">The Union Group Headquarters</p>
                                    <p className="sub-title">
                                        Plaza Mutiara Lt. 5 Suite 503.
                                        <br />
                                        Jl.Dr. Ide Anak Agung Gde Agung Kav. 1-2 No. 1 & 2
                                        <br />
                                        Jakarta Selatan 12950
                                    </p>
                                </div>
                                <div className="list-group inline-content transparent mb-3">
                                    <div className="list-group-item mb-3">
                                        <div className="icon">
                                            <i class="fal fa-phone"></i>
                                        </div>
                                        <div className="list-group-item-content">
                                            <p>+6221 2510191</p>
                                        </div>
                                    </div>
                                    <div className="list-group-item">
                                        <div className="icon">
                                            <i class="fal fa-envelope"></i>
                                        </div>
                                        <div className="list-group-item-content">
                                                <p>info@uniongroupjakarta.com</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="heading mb-0">
                                    <p className="title sm mb-3">Career Opportunities</p>
                                    <div className="list-group inline-content transparent">
                                        <div className="list-group-item">
                                            <div className="icon">
                                                <i class="fal fa-envelope"></i>
                                            </div>
                                            <div className="list-group-item-content">
                                                <p>recruitment@uniongroupjakarta.com</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Contact
